<template>
  <div class="top-left w50 left margin margin_r_hf margin_l_c back">
    <div class="styleCard" v-if="auth.user.id !== 114">
      <!--      <deposits-main-charts v-show="mainView === 'null'" />-->

<!--      default main chart-->
      <default-charts
          v-if="
          mainView === 'call_again' ||
          mainView === 'register' ||
          mainView === 'deposits' ||
          mainView === null"
          :main-sector="mainView"
          :main-data="multiSelectChartData"
          :tabs="this"
          :presets-tabs="this['presets']"
          :stats-tabs="this['statsPresets']"
          :main-view="mainView"

      />

<!--      <scheduled-calls-charts-->
<!--        v-show="mainView === 'call_again'"-->
<!--        :main-sector="mainView"-->
<!--        :main-data="multiSelectChartData"-->
<!--        :tabs="this['call_again']"-->
<!--        :presets-tabs="this['presets']"-->
<!--        :stats-tabs="this['statsPresets']"-->
<!--      />-->

      <na-charts
        v-if="mainView === 'no_answer'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

      <ld-charts
        v-if="mainView === 'leads'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

      <rf-charts
        v-if="mainView === 'referral'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

<!--      <dp-charts-->
<!--        v-if="mainView === 'deposits' || mainView === null"-->
<!--        :main-sector="mainView"-->
<!--        :main-data="multiSelectChartData"-->
<!--        :tabs="this['deposits']"-->
<!--        :presets-tabs="this['presets']"-->
<!--        :stats-tabs="this['statsPresets']"-->
<!--      />-->
      <as-charts
        v-if="mainView === 'assignments'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

      <transfers-charts
        v-if="mainView === 'transfer'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

      <countries-charts
        v-if="mainView === 'countries'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :stats-tabs="this['statsPresets']"
      />

      <questions-charts
        v-if="mainView === 'questions'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
      />

<!--      <reg-charts-->
<!--          v-if="mainView === 'register'"-->
<!--          :main-sector="mainView" -->
<!--      />-->

      <campaigns-charts
        v-if="mainView === 'advertising'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
      ></campaigns-charts>
      <CampaignsChartsClickType
        v-if="mainView === 'click_type'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
      />
      <!--      v-if="mainView === 'campaign'"-->
      <dynamic-line-chart
        v-show="chartsMainView === 'DYNAMIC'"
      ></dynamic-line-chart>
      <live-data-charts v-show="chartsMainView === 'LIVE'"></live-data-charts>
      <!--      <deposits-charts v-show="chartsMainView === 'eDEP'"> </deposits-charts>-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
// import DepositsCharts from "../components/block_1/DepositsCharts.component";
import CountriesCharts from "../components/block_1/CountriesCharts.component";
import QuestionsCharts from "../components/block_1/QuestionsCharts.component";
import CampaignsCharts from "../components/block_1/CampaignsCharts.component";
import TransfersCharts from "../components/block_1/TransfersCharts.component";
import ScheduledCallsCharts from "../components/block_1/ScheduledCallsCharts.component";
import NaCharts from "../components/block_1/NACharts.component";
import RfCharts from "../components/block_1/RfCharts.component";
import LdCharts from "../components/block_1/LdCharts.component";
import DpCharts from "../components/block_1/DpCharts.component";
import AsCharts from "../components/block_1/AsCharts.component";
// import RegCharts from "../components/block_1/RegCharts.component";
import RegCharts from "../components/block_1/regNewCharts.component";
import DynamicLineChart from "../components/DynamicLineChart.component";
import LiveDataCharts from "../components/block_1/LiveDataCharts.component";
import DefaultCharts from "../components/block_1/DefaultCharts.component";
// import DepositsMainCharts from "@/features/company.feature/sub_features.company/graph.sub-feature.company/new_graphs/main_graphs/DepositsMainCharts";

import leads from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ld/leads";
import assignments from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/assignments/assignments";
import call_again from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ca/call_again";
import deposits from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/dp/deposits";
import transfer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/tr/transfer";
import countries from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/countries/countries";
import sms from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/sms/sms";
import referral from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/referral/referral";
import no_answer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/no_answer/no_answer";
import presets from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/presets/presets";
import statsPresets from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/stats/statsTabs";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import CampaignsChartsClickType from "../components/block_1/CampaignsChartsClickType.component";

export default {
  name: "graph-container",
  mixins: [
    UsersPermissionCheck,
    leads,
    assignments,
    call_again,
    deposits,
    transfer,
    countries,
    sms,
    referral,
    no_answer,
    presets,
    statsPresets
  ],
  components: {
    DefaultCharts,
    CampaignsChartsClickType,
    LiveDataCharts,
    // DepositsCharts,
    CampaignsCharts,
    TransfersCharts,
    // ScheduledCallsCharts,
    NaCharts,
    RfCharts,
    LdCharts,
    // DpCharts,
    AsCharts,
    // RegCharts,
    DynamicLineChart,
    // MainChartsController,
    // DepositsMainCharts,
    CountriesCharts,
    QuestionsCharts
  },

  computed: {
    ...mapGetters("clients", ["updateDepCharts"]),
    ...mapActions("clients", ["showAddEditUsers"]),
    ...mapState("user", ["auth"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "updateDepCharts",
      "campChartData",
      "chartsViewBlocks",
      "multiSelectChartData"
    ])
  },

  data() {
    return {
      mainView: null,
      selectedUserGraphTab: "BROKERS",
      selectedGraphTab: "MONTH",
      tabFontSize: "11px",
      blockNumber: 1
    };
  },
  created() {
    this.mainView = "deposits";
  },
  watch: {
    chartsViewBlocks: function() {
      this.mainView = this.chartsViewBlocks[this.blockNumber];
    }
  }
};
</script>

<style scoped>
.nav-tabs a {
  height: 25px;
  padding: 5px;
}
.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-family: Montserrat;
  font-size: 10pt;
  font-weight: bold;
  color: #1e88e5;
}

.w50 {
  width: calc(45%);
}
.left {
  float: left;
}
.margin {
  /*margin: 0.5rem;*/
}
.margin_r_hf {
  /*margin-right: 0.2rem;*/
}
.margin_l_c {
  /*margin-left: 0;*/
}

.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 172px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}

.sysChatActions button:hover img {
  transform: translateX(-10px);
}
.sysChatActions button img {
  transition: transform 0.3s ease;
}
.sysChatActions button {
  width: 75px;
  background: none;
  border: 0;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 37px;
}
.back {
  background: white;
}
.styleCard {
  overflow: hidden;
  min-height: 100%;
  position: relative;
  font-family: Montserrat;
  padding-top: 12px;
  padding-right: 12px;

  /*padding-left: 12px;*/
}
.margin_r_hf {
  /*margin:-2px;*/
}
</style>
